// @flow
// $FlowFixMe
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { RSS } from '@finect/tabular-icons/rss';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const FollowAction = styled.div`
  display: inline-block;
  position: relative;
  ${({ button, following, theme }) =>
    (button
      ? `
    flex-shrink: 0;
    padding: 4px 16px 3px;
    aidth: 94px;
    border: 1px solid ${following ? 'transparent' : theme.borderColor};
    ${following ? `background-color: ${theme.colors.secondary};` : ''};
    font-weight: 500;
    text-align: center;
    `
      : 'padding-left: 19px; margin-left: 12px;')};
  border-radius: ${({ theme }) => theme.borderRadius};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes['-1'].size};
  line-height: ${({ theme }) => theme.fontSizes['0'].lineHeight};
  color: ${({ following, theme }) => (following ? theme.colors.uiLL : theme.colors.uiDDD)};

  /* stylelint-disable */
  @media (hover: hover), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    &:hover {
      ${({ button, theme }) =>
    (button
      ? `
          border-color: transparent;
          background-color: ${theme.colors.secondary};
        `
      : null)};
      color: ${({ theme }) => theme.colors.uiLL};
    }
  }

  /* stylelint-enable */
  svg {
    position: absolute;
    top: 3.5px;
    left: 0;
    opacity: ${({ following }) => (following ? 1 : 0.5)};
    color: ${({ theme, following }) => (following ? theme.colors.ui : theme.colors.terciaryLL)};
  }
`;

export const FollowButton = styled.button`
  margin-left: 12px;

  span {
    ${({ theme, following }) => (following ? `background-color: ${theme.colors.secondary}` : null)};
    color: ${({ theme }) => theme.fontColor};
  }

  &:active {
    span {
      background-color: ${({ theme, following }) => (following ? theme.colors.secondary : theme.lightGrey)};
      color: ${({ theme }) => theme.colors.positive};
    }
  }
  /* stylelint-disable */
  @media (hover: hover), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    &:hover,
    &:active {
      color: ${({ theme }) => theme.fontColor};
      span {
        background-color: ${({ theme }) => theme.colors.secondary};
        color: ${({ theme }) => theme.fontColor};
      }
    }
  }
  /* stylelint-enable */
  ${maxMediaQueries.phone`
    margin-top: 12px;
    margin-left: 0;
  `};
`;

type Props = {
  button?: boolean,
  buttonMini?: boolean,
  following: boolean | number,
  followAction: Function
};

export const Follow = ({ button, buttonMini, following, followAction }: Props) => (
  <Fragment>
    {button ? (
      <FollowButton following={following} onClick={followAction}>
        <span>
          <RSS size="18" strokeWidth="2.4" />
        </span>
        {following ? 'Siguiendo' : 'Seguir'}
      </FollowButton>
    ) : (
      <FollowAction button={buttonMini} following={following} onClick={followAction}>
        {!buttonMini ? <RSS size="14" strokeWidth="3.4" /> : null}
        {following ? 'Siguiendo' : 'Seguir'}
      </FollowAction>
    )}
  </Fragment>
);
